import React, { useState, useMemo, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DataTable from './../../../../Layout/Table/TableLayoutOpp';
import { FaEdit, FaTrash, FaEye, FaDownload, FaComment, FaUserPlus, FaCalendarAlt, FaTimes, FaCopy } from 'react-icons/fa';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import Navbar from '../../../../Shared/Navbar/Navbar';
import { baseURL, webhookUrl } from '../../../../Apiservices/Api';
import axios from 'axios';
import { AuthContext } from "../../../../AuthContext/AuthContext";
import { FontSizeContext } from '../../../../Shared/Font/FontContext';
import * as XLSX from 'xlsx';
import { HiUserGroup } from "react-icons/hi"; // Import icon
import { FaSave } from 'react-icons/fa';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import { Form } from "react-bootstrap";
import CommentsModalpop from '../ViewLeads/CommentsModalPop/CommentsModalpop'; 
import Loader from '../../../../Loader/Loader';

import './ViewLeads.css'

const AdminViewLeads = () => {

  const queryClient = useQueryClient();

  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['leads'],
    refetchInterval: 3000, // every 30 sec
    queryFn: async () => {
      const response = await fetch(`${baseURL}/api/addleads/statuslead`);
      const json = await response.json();

      const list = Array.isArray(json.data) ? json.data : [];
      return list.filter(e => e.adminAssign !== 'admin');
    },
    keepPreviousData: true,
  });



  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const { authToken, userId } = useContext(AuthContext);
  const [message, setMessage] = useState(null);
  const location = useLocation();
  const [associatesByManager, setAssociatesByManager] = useState({});
  const [isAddingComment, setIsAddingComment] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);

  const [searchTerm, setSearchTerm] = useState(localStorage.getItem("searchTerm-1") || "");
  const [filterStatus, setFilterStatus] = useState(localStorage.getItem("filterStatus-1") || "");
  const [filterDestination, setFilterDestination] = useState(localStorage.getItem("filterDestination-1") || "");
  const [filterOppStatus1, setFilterOppStatus1] = useState(localStorage.getItem("filterOppStatus1-1") || "Open");
  const [filterOppStatus2, setFilterOppStatus2] = useState(localStorage.getItem("filterOppStatus2-1") || "");
  const [filterManager, setFilterManager] = useState(localStorage.getItem("filterManager-1") || "");
  const [filterAssignee, setFilterAssignee] = useState(localStorage.getItem("filterAssignee-1") || "");
  const [filterStartDate, setFilterStartDate] = useState(localStorage.getItem("filterStartDate-1") || "");
  const [filterEndDate, setFilterEndDate] = useState(localStorage.getItem("filterEndDate-1") || "");
  const [appliedFilterStartDate, setAppliedFilterStartDate] = useState(localStorage.getItem("appliedFilterStartDate-1") || "");
  const [appliedFilterEndDate, setAppliedFilterEndDate] = useState(localStorage.getItem("appliedFilterEndDate-1") || "");

  // const [showDateRange, setShowDateRange] = useState(false);

  // const [data, setData] = useState([]); // Initialize to an empty array

  const [showCommentModal, setShowCommentModal] = useState(false);
  const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);


  const [showDateRange, setShowDateRange] = useState(
    localStorage.getItem("showDateRange-1") === "true"
  );

  // Save state to localStorage when values change
  useEffect(() => {
    localStorage.setItem("showDateRange-1", showDateRange);
  }, [showDateRange]);

  useEffect(() => {
    setPageIndex(0);
  }, [searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2, filterManager, filterAssignee, appliedFilterStartDate, appliedFilterEndDate]);
  const handleEdit = (leadId, currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/a-edit-lead/${leadId}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: leadId },
    });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });


  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page"));

    if (!isNaN(pageFromUrl)) {
      setPageIndex(pageFromUrl - 1);
    }
  }, [location.search]);




  const handleAddUser = (lead, currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/a-create-customer-opportunity/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`);
  };

  const handleViewLeads = (lead, currentPage) => {
    const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
    navigate(`/a-view-lead/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { source: "a-all-leads" },
    });
  };


  const handleCommentClick = (lead) => {
    setSelectedLeadForComment(lead);
    setShowCommentModal(true);
  };
  const handleArchive = async (leadid) => {
    if (!window.confirm("Are you sure you want to archive this lead?")) return;

    // ✅ Optimistic — remove instantly
    queryClient.setQueryData(['leads'], (old = []) =>
      old.filter((i) => i.leadid !== leadid)
    );

    try {
      await fetch(`${baseURL}/api/archiveByLeadId/${leadid}`, { method: "PUT" });
      setMessage("Lead archived successfully.");
      setTimeout(() => setMessage(""), 1000);
    } catch {
      queryClient.invalidateQueries(['leads']); // ✅ rollback
      setMessage("Archive failed, reverting...");
      setTimeout(() => setMessage(""), 1000);
    }
  };

  const [dropdownOptions, setDropdownOptions] = useState({
  primary: [],
  secondary: {}
});

useEffect(() => {
  fetchLeadStatus();
}, []);

const fetchLeadStatus = async () => {
  try {
    const res = await axios.get(`${baseURL}/api/lead-status`);
    
    setDropdownOptions({
      primary: res.data.primary || [],
      secondary: res.data.secondary || {}
    });

  } catch (error) {
    console.error("Error fetching lead status:", error);
  }
};


  // const dropdownOptions = {
  //   primary: ["New", "No Response", "Duplicate", "False Lead", "Junk", "Plan Cancelled"],
  //   secondary: {
  //     New: ["Yet to Contact","Not picking up call", "Asked to call later"],
  //     "No Response": [],
  //     Duplicate: [],
  //     "False Lead": [],
  //     Junk: ["Plan Cancelled", "Plan Delayed", "Already Booked", "Others"],
  //     "Plan Cancelled": [],
  //   },
  // };

  // const handlePrimaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid == rowId
  //         ? {
  //           ...row,
  //           primaryStatus: value,
  //           secondaryStatus: "",
  //         }
  //         : row
  //     )
  //   );
  // };

  // const handleSecondaryStatusChange = (value, rowId) => {
  //   setData((prevData) =>
  //     prevData.map((row) =>
  //       row.leadid == rowId ? { ...row, secondaryStatus: value } : row
  //     )
  //   );
  // };
  const updateLeadStatus = async (leadId, primaryStatus, secondaryStatus) => {
    // ✅ Optimistic — instant UI update
    queryClient.setQueryData(['leads'], (old = []) =>
      old.map((r) =>
        r.leadid === leadId
          ? { ...r, primaryStatus, secondaryStatus: secondaryStatus || '' }
          : r
      )
    );

    try {
      const response = await axios.put(`${baseURL}/api/leads/status/${leadId}`, {
        primaryStatus,
        secondaryStatus: secondaryStatus || '',
      });
      if (response.status === 200) {
        setMessage('Status updated successfully.');
        setTimeout(() => setMessage(''), 3000);
        return true;
      }
    } catch {
      queryClient.invalidateQueries(['leads']); // ✅ rollback
      setMessage('Update failed, reverting...');
      setTimeout(() => setMessage(''), 3000);
    }
    return false;
  };



  const [managers, setManagers] = useState([]);
  const [manager, setManager] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const handleAddLead = () => {
    navigate('/a-add-leads');
  };

  useEffect(() => {
    const fetchManager = async () => {
      try {
        const response = await fetch(`${baseURL}/managers`);
        if (!response.ok) {
          throw new Error("Failed to fetch managers");
        }
        const result = await response.json();
        setManager(result.data);
      } catch (err) {
        console.error("Error fetching managers:", err.message);
        // setError(err.message);
      }
    };

    fetchManager();
  }, []);

  const handleAssignToChange = async (assignee, leadid, managerid, status) => {
    // ✅ Optimistic — instant UI update
    queryClient.setQueryData(['leads'], (old = []) =>
      old.map((lead) =>
        lead.leadid == leadid
          ? { ...lead, assign_to_manager: assignee, managerid }
          : lead
      )
    );

    try {
      const response = await fetch(`${baseURL}/update-assignee`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ leadid, assignee, managerid, status }),
      });
      const resData = await response.json();
      setMessage(resData.message);
      setTimeout(() => setMessage(''), 1000);
    } catch {
      queryClient.invalidateQueries(['leads']); // ✅ rollback
      setMessage('Assign failed, reverting...');
      setTimeout(() => setMessage(''), 1000);
    }
  };


  const fetchManagers = async () => {
    try {
      const response = await axios.get(`${baseURL}/employees/managers`);
      setManagers(response.data.data);
    } catch (error) {
      console.error("Error fetching managers:", error);
    }
  };

  useEffect(() => {
    fetchManagers();
  }, [userId]);
  useEffect(() => {
    const fetchAssociatesForManagers = async () => {
      const associatesData = {};
      for (const manager of managers) {
        try {
          const response = await fetch(`${baseURL}/associates/${manager.id}`);
          const data = await response.json();
          associatesData[manager.id] = data;
        } catch (error) {
          console.error("Error fetching associates: ", error);
        }
      }
      setAssociatesByManager(associatesData);
    };

    if (managers.length > 0) {
      fetchAssociatesForManagers();
    }
  }, [managers]);
  const handleSelfAssign = async (leadid) => {
    // ✅ Optimistic — remove from list instantly
    queryClient.setQueryData(['leads'], (old = []) =>
      old.filter((lead) => lead.leadid != leadid)
    );

    try {
      const response = await axios.post(`${baseURL}/api/assign-admin`, { leadid });
      setMessage(response.data.message);
      setTimeout(() => setMessage(''), 1000);
    } catch {
      queryClient.invalidateQueries(['leads']); // ✅ rollback — lead reappears
      setMessage('Self assign failed, reverting...');
      setTimeout(() => setMessage(''), 1000);
    }
  };



  useEffect(() => {
    localStorage.setItem("searchTerm-1", searchTerm);
    localStorage.setItem("filterStatus-1", filterStatus);
    localStorage.setItem("filterDestination-1", filterDestination);
    localStorage.setItem("filterOppStatus1-1", filterOppStatus1);
    localStorage.setItem("filterOppStatus2-1", filterOppStatus2);
    localStorage.setItem("filterManager-1", filterManager);
    localStorage.setItem("filterAssignee-1", filterAssignee);
    localStorage.setItem("filterStartDate-1", filterStartDate);
    localStorage.setItem("filterEndDate-1", filterEndDate);
    localStorage.setItem("appliedFilterStartDate-1", appliedFilterStartDate);
    localStorage.setItem("appliedFilterEndDate-1", appliedFilterEndDate);
  }, [
    searchTerm, filterStatus, filterDestination, filterOppStatus1, filterOppStatus2,
    filterManager, filterAssignee, filterStartDate, filterEndDate,
    appliedFilterStartDate, appliedFilterEndDate
  ]);

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("");
    setFilterDestination("");
    setFilterOppStatus1("Open");
    setFilterOppStatus2("");
    setFilterManager("");
    setFilterAssignee("");
    setFilterStartDate("");
    setFilterEndDate("");
    setAppliedFilterStartDate("");
    setAppliedFilterEndDate("");

    // ADD THESE 3 LINES:
    setPageIndex(0);
    const url = new URL(window.location);
    url.searchParams.delete('page');
    url.searchParams.set('pageSize', '20');
    url.searchParams.delete('pageSize');

    window.history.pushState({}, '', url);


    localStorage.removeItem("adminleadsFilters");
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const matchesSearchTerm =
        !searchTerm ||
        Object.values(item).some(
          (val) =>
            val &&
            val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );

      const actualPrimaryStatus = item.primaryStatus ? item.primaryStatus.toLowerCase() : "Open";

      const matchesPrimaryStatus =
        !filterOppStatus1 || actualPrimaryStatus === filterOppStatus1.toLowerCase();
      const matchesSecondaryStatus =
        !filterOppStatus2 || (item.secondaryStatus && item.secondaryStatus.toLowerCase() == filterOppStatus2.toLowerCase());
      const matchesAssignee = !filterAssignee || (item.assignedSalesName && item.assignedSalesName.toLowerCase() == filterAssignee.toLowerCase());
      // Modified manager matching logic
      const matchesManager = !filterManager
        ? true
        : filterManager.endsWith('+Self')
          ? (item.managerAssign && managers.some(
            m => m.id == item.managerAssign &&
              m.name === filterManager.replace('+Self', '')
          ))
          : (item.assign_to_manager && item.assign_to_manager.toLowerCase() == filterManager.toLowerCase());
      // const matchesManager = !filterManager || (item.assign_to_manager && item.assign_to_manager.toLowerCase() == filterManager.toLowerCase());
      const matchesDestination = !filterDestination || (item.destination && item.destination.toLowerCase() == filterDestination.toLowerCase());
      const matchesDateRange = (() => {
        if (appliedFilterStartDate && appliedFilterEndDate) {
          const start = new Date(appliedFilterStartDate);
          const end = new Date(appliedFilterEndDate).setHours(23, 59, 59, 999);
          const createdAt = new Date(item.created_at);
          return createdAt >= start && createdAt <= end;
        }
        return true;
      })();

      return matchesSearchTerm && matchesPrimaryStatus && matchesDestination && matchesManager && matchesAssignee && matchesSecondaryStatus && matchesDateRange;
    });
  }, [searchTerm, filterOppStatus1, filterOppStatus2, filterManager, filterAssignee, filterDestination, appliedFilterStartDate, appliedFilterEndDate, data]);

  const handleAssignLead = async (leadid, associateObj, status) => {
    if (!associateObj?.id || !associateObj?.name) {
      setMessage('Please select a valid associate.');
      setTimeout(() => setMessage(''), 1000);
      return;
    }

    // ✅ Optimistic — instant UI update
    queryClient.setQueryData(['leads'], (old = []) =>
      old.map((lead) =>
        lead.leadid == leadid
          ? {
            ...lead,
            assignedSalesId: associateObj.id,
            assignedSalesName: associateObj.name,
          }
          : lead
      )
    );

    try {
      const response = await axios.post(`${baseURL}/api/admin-assign-lead`, {
        leadid,
        employeeId: associateObj.id,
        employeeName: associateObj.name,
        status,
      });
      setMessage(response.data.message);
      setTimeout(() => setMessage(''), 1000);
    } catch {
      queryClient.invalidateQueries(['leads']); // ✅ rollback
      setMessage('Assign failed, reverting...');
      setTimeout(() => setMessage(''), 1000);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page"));
    const pageSizeFromUrl = parseInt(params.get("pageSize"));

    if (!isNaN(pageFromUrl)) {
      setPageIndex(pageFromUrl - 1);
    }

  }, [location.search]);

  const columns = useMemo(
    () => [

      {
        Header: "LeadId",
        accessor: "leadid",

      },
      {
        Header: "Name",
        accessor: "name",
        Cell: ({ row }) => {
          const currentPage = pageIndex;
          const params = new URLSearchParams(location.search);
          const pageSize = params.get('pageSize') || '20';
          return (

            <div>
              <div
                style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                onClick={() => handleViewLeads(row.original, currentPage, pageSize)} // Navigate on click
              >
                {row.original.name}
              </div>
            </div>
          )
        }

      },

      {
        Header: "Mobile",
        accessor: "phone_number",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href={`https://wa.me/${row.original.phone_number}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
              title="Chat on WhatsApp"
            >
              {row.original.phone_number}
            </a>
            <FaCopy
              style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.phone_number)}
              title="Copy Phone Number"
            />
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Push copy button to the right
              width: "100%",
              maxWidth: "200px", // Adjust width as needed
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100px",
              }}
              title={row.original.email} // Show full email on hover
            >
              {row.original.email}
            </div>
            <FaCopy
              style={{ cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.email)}
              title="Copy Email"
            />
          </div>
        ),
      },
      {
        Header: "Destination",
        accessor: "destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100px",
            }}
            title={row.original.destination}
          >
            {row.original.destination}
          </div>
        ),
      },

      {
        Header: "Lead Status",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const { primaryStatus, secondaryStatus, leadid } = row.original;

          // Local state for unsaved changes
          const [localPrimary, setLocalPrimary] = useState(primaryStatus);
          const [localSecondary, setLocalSecondary] = useState(secondaryStatus);
          const [isDirty, setIsDirty] = useState(false);

          // Reset local state when original props change
          useEffect(() => {
            setLocalPrimary(primaryStatus);
            setLocalSecondary(secondaryStatus);
            setIsDirty(false);
          }, [primaryStatus, secondaryStatus]);

          // Get secondary options for current primary selection
          const secondaryOptions = localPrimary ? (dropdownOptions.secondary[localPrimary] || []) : [];
          const isSecondaryDisabled = !localPrimary || secondaryOptions.length === 0;

          const handlePrimaryChange = (e) => {
            const newPrimary = e.target.value;
            setLocalPrimary(newPrimary);
            setLocalSecondary(""); // Reset secondary when primary changes
            setIsDirty(true);
          };

          const handleSecondaryChange = (e) => {
            setLocalSecondary(e.target.value);
            setIsDirty(true);
          };

          const canSave =
            localPrimary &&
            (secondaryOptions.length === 0 || (secondaryOptions.length > 0 && localSecondary));


          const handleSave = async () => {
            try {
              // Update both statuses in one API call
              await updateLeadStatus(leadid, localPrimary, localSecondary);

              // Update local data state only after successful API call
              queryClient.setQueryData(['leads'], (oldData = []) =>
                oldData.map((row) =>
                  row.leadid === leadid
                    ? {
                      ...row,
                      primaryStatus: localPrimary,
                      secondaryStatus: localSecondary,
                    }
                    : row
                )
              );


              setIsDirty(false);
            } catch (error) {
              console.error('Error saving status:', error);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              {/* Primary Status Dropdown */}
              <select
                value={localPrimary || ""}
                onChange={handlePrimaryChange}
                className="form-select me-2"
                style={{ fontSize: fontSize }}
              >
                <option value="">Select Primary</option>
                {dropdownOptions.primary.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Secondary Status Dropdown */}
              <select
                value={localSecondary || ""}
                onChange={handleSecondaryChange}
                className="form-select me-2"
                style={{ fontSize: fontSize }}
                disabled={isSecondaryDisabled}
              >
                <option value="">{isSecondaryDisabled ? "Select Secondary" : "Select Secondary"}</option>
                {secondaryOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Save Button (only shown when there are unsaved changes) */}
              {isDirty && (
                <FaSave
                  onClick={canSave ? handleSave : undefined}
                  title={canSave ? "Save changes" : "Select secondary status to enable"}
                  style={{
                    color: canSave ? "#ff9966" : "#ccc",
                    cursor: canSave ? "pointer" : "not-allowed",
                    fontSize: "60px",
                  }}
                />
              )}

            </div>
          );
        },
      },

      {
        Header: 'Source',
        accessor: 'sources',
        width: 10// fixed width in pixels
      },

      {
        Header: () => <div style={{ whiteSpace: "nowrap" }}>Customer Status</div>,
        accessor: "customer_status",
      }
      ,

      {
        Header: "Manager ",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const assignedManagerId = row.original.managerid || "";
          const assignedManagerName = row.original.assign_to_manager || "";

          const [selectedManager, setSelectedManager] = useState(
            assignedManagerId ? `${assignedManagerId}|${assignedManagerName}` : ""
          );
          const [showIcon, setShowIcon] = useState(false);

          useEffect(() => {
            setSelectedManager(
              assignedManagerId ? `${assignedManagerId}|${assignedManagerName}` : ""
            );
            setShowIcon(false);
          }, [assignedManagerId, assignedManagerName]);

          const handleChange = (e) => {
            const newValue = e.target.value;
            setSelectedManager(newValue);
            setShowIcon(newValue !== `${assignedManagerId}|${assignedManagerName}`);
          };

          const handleAssignClick = async () => {
            if (selectedManager) {
              const [managerid, assignee] = selectedManager.split("|");

              if (selectedManager == "self") {
                // Call the new API for self assignment
                await handleSelfAssign(row.original.leadid);
              } else {
                handleAssignToChange(assignee, row.original.leadid, managerid, row.original.status,);
              }

              // await handleAssignToChange(assignee, row.original.leadid, managerid);

              // ✅ Update row data manually to trigger re-render
              row.original.managerid = managerid;
              row.original.assign_to_manager = assignee;

              // ✅ Update state to reflect change instantly
              setSelectedManager(`${managerid}|${assignee}`);
              setShowIcon(false);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }}>
              <select
                value={selectedManager}
                onChange={handleChange}
                className="form-select me-2"
                style={{ maxWidth: "150px", fontSize: fontSize }}
              >
                <option value="">Select Assignee</option>
                <option value="self">Self</option>
                {managers.map((manager, index) => (
                  <option key={index} value={`${manager.id}|${manager.name}`}>
                    {manager.name}
                  </option>
                ))}
              </select>
              {showIcon && (
                <HiUserGroup
                  style={{ color: "#ff9966", cursor: "pointer", fontSize: "18px" }}
                  onClick={handleAssignClick}
                />
              )}
            </div>
          );
        },
      },

      {
        Header: "Associate",
        Cell: ({ row }) => {
          const { fontSize } = useContext(FontSizeContext);
          const initialAssociateValue = row.original.assignedSalesId
            ? `${row.original.assignedSalesId}|${row.original.assignedSalesName}`
            : "";

          const [selectedAssociate, setSelectedAssociate] = useState(initialAssociateValue);
          const [showIcon, setShowIcon] = useState(false);

          const managerId = row.original.managerid;
          const associates = managerId ? associatesByManager[managerId] || [] : [];

          useEffect(() => {
            setSelectedAssociate(initialAssociateValue);
            setShowIcon(false);
          }, [row.original.assignedSalesId, row.original.assignedSalesName]);

          const handleChange = (e) => {
            const newValue = e.target.value;
            setSelectedAssociate(newValue);
            setShowIcon(newValue !== initialAssociateValue);
          };

          const handleAssignClick = async () => {
            if (selectedAssociate) {
              const [associateId, associateName] = selectedAssociate.split("|");
              await handleAssignLead(row.original.leadid, { id: associateId, name: associateName }, row.original.status);
              // No need to update row.original directly; state is already updated in handleAssignLead
              setShowIcon(false);
            }
          };

          return (
            <div className="d-flex align-items-center" style={{ fontSize: fontSize }} >
              <select
                value={selectedAssociate}
                onChange={handleChange}
                className="form-select me-2" style={{ fontSize: fontSize }}

              >
                <option value="">Select Associate</option>
                {associates.map((associate, index) => (
                  <option key={index} value={`${associate.id}|${associate.name}`}>
                    {associate.name}
                  </option>
                ))}
              </select>
              {showIcon && (
                <HiUserGroup
                  style={{ color: "#ff9966", cursor: "pointer", fontSize: "18px" }}
                  onClick={handleAssignClick}
                />
              )}
            </div>
          );
        },
      },

      {
        Header: "Actions",
        Cell: ({ row }) => {
          const currentPage = pageIndex;
          const params = new URLSearchParams(location.search);
          const pageSize = params.get('pageSize') || '20';
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaEdit
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleEdit(row.original.leadid, currentPage, pageIndex)}
              />
              <FaTrash
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleArchive(row.original.leadid, currentPage, pageSize)}
              />
              <FaEye
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleViewLeads(row.original, currentPage, pageSize)}
              />
              <FaUserPlus
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleAddUser(row.original, currentPage, pageIndex)}
              />
              <FaComment
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => handleCommentClick(row.original,)}
              />
              {/* <FaComment
                style={{ color: "#ff9966", cursor: "pointer" }}
                onClick={() => navigate(`/a-comments/${row.original.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`)}
              /> */}
            </div>
          );
        },
      },


    ],
    [dropdownOptions, pageIndex, managers,location, associatesByManager]
  );

  const uniqueDestinations = useMemo(() => {
    const normalizedDestinations = data
      .map(item => item.destination?.trim())
      .filter(dest => dest) // Remove empty values
      .map(dest => dest.toLowerCase()); // Convert to lowercase for uniqueness

    // Get unique values and format them
    return [...new Set(normalizedDestinations)]
      .map(dest => dest.charAt(0).toUpperCase() + dest.slice(1)); // Capitalize first letter
  }, [data]);


  // Extract team members for the selected manager
  const teamMembers = useMemo(() => {
    if (!filterManager) return [];
    const selectedManager = managers.find((manager) => manager.name.toLowerCase() == filterManager.toLowerCase());
    return selectedManager ? selectedManager.teamMembers : [];
  }, [filterManager, managers]);



  return (
    <div className="admin-ViewLeadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`admin-ViewLead ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-ViewLead-container mb-5">
          <div className="admin-ViewLead-table-container">
            <Row className="mb-3">
              <Col className="d-flex justify-content-between align-items-center">
                <h3>Lead Details</h3>
                {message && <div className="alert alert-info">{message}</div>}
                <Button onClick={handleAddLead}>Add Leads</Button>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center">
              <Col md={6} className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Free Text Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    localStorage.setItem("searchTerm-1", e.target.value);
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                />
                {showDateRange ? (
                  <FaTimes
                    onClick={() => {
                      setShowDateRange(false);
                      localStorage.setItem("showDateRange-1", "false");
                      setFilterStartDate("");
                      setFilterEndDate("");
                      setAppliedFilterStartDate("");
                      setAppliedFilterEndDate("");
                      localStorage.removeItem("filterStartDate-1");
                      localStorage.removeItem("filterEndDate-1");
                      localStorage.removeItem("appliedFilterStartDate-1");
                      localStorage.removeItem("appliedFilterEndDate-1");
                    }}
                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                    title="Hide Date Range"
                  />
                ) : (
                  <FaCalendarAlt
                    onClick={() => {
                      setShowDateRange(true);
                      localStorage.setItem("showDateRange-1", "true");
                    }}
                    style={{ cursor: "pointer", fontSize: "1.5rem" }}
                    title="Show Date Range"
                  />
                )}
                {showDateRange && (
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="date"
                      className="form-control"
                      value={filterStartDate}
                      onChange={(e) => setFilterStartDate(e.target.value)}
                    />
                    <span>to</span>
                    <input
                      type="date"
                      className="form-control"
                      value={filterEndDate}
                      onChange={(e) => setFilterEndDate(e.target.value)}
                    />
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setAppliedFilterStartDate(filterStartDate);
                        setAppliedFilterEndDate(filterEndDate);
                        // ADD THESE 3 LINES:
                        setPageIndex(0);
                        const url = new URL(window.location);
                        url.searchParams.delete('page');
                        window.history.pushState({}, '', url);
                      }}
                    >
                      OK
                    </button>
                  </div>
                )}
              </Col>
              <Col md={3} className="d-flex justify-content-end">
                <button className="btn btn-secondary" onClick={clearFilters}>Clear Filters</button></Col>
              {/* <Col md={3} className="d-flex justify-content-end">
                <button className="btn btn-success" onClick={downloadExcel}>
                  <FaDownload /> Download Excel</button></Col> */}
            </Row>
            <Row className="mb-3">
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterDestination}
                  onChange={(e) => {
                    setFilterDestination(e.target.value);
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >                  <option value=""> Destinations</option>
                  {uniqueDestinations.map((dest) => (
                    <option key={dest} value={dest}>{dest}</option>
                  ))}
                </select>
              </Col>
              <Col md={2}>
                <select
                  className="form-select"
                  value={filterOppStatus1}
                  onChange={(e) => {
                    setFilterOppStatus1(e.target.value);
                    setFilterOppStatus2("");
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >               <option value="">Primary Status</option>

    {dropdownOptions.primary.map((status) => (
      <option key={status} value={status}>
        {status}
      </option>
    ))}
                </select>
              </Col>

              <Col md={2}>
                <select
                  className="form-select"
                  value={filterOppStatus2}
                  onChange={(e) => {
                    setFilterOppStatus2(e.target.value);
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                  <option value="">Secondary Status</option>
                  {dropdownOptions.secondary[filterOppStatus1]?.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </Col>
              <Col md={2}>
                <select
                  className="form-select"
                  value={filterManager}
                  onChange={(e) => {
                    setFilterManager(e.target.value);
                    setFilterAssignee("");
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >
                  <option value=""> Managers</option>
                  {Array.isArray(managers) &&
                    managers.flatMap((manager) => [
                      <option key={`${manager.id}-regular`} value={manager.name}>
                        {manager.name}
                      </option>,
                      <option key={`${manager.id}-self`} value={`${manager.name}+Self`}>
                        {manager.name} + Self
                      </option>
                    ])
                  }
                </select>
              </Col>
              <Col md={3}>
                <select
                  className="form-select"
                  value={filterAssignee}
                  onChange={(e) => {
                    setFilterAssignee(e.target.value);
                    // ADD THESE 3 LINES:
                    setPageIndex(0);
                    const url = new URL(window.location);
                    url.searchParams.delete('page');
                    window.history.pushState({}, '', url);
                  }}
                >                  <option value="">Associates</option>
                  {teamMembers.map((member) => (
                    <option key={member.id} value={member.name}>{member.name}</option>
                  ))}
                </select>
              </Col>
            </Row>

            {isLoading ? (
              <Loader />
            ) : data.length === 0 ? (
              <div className="text-center p-5">
                <p>No data available</p>
              </div>
            ) : (
              <DataTable
                columns={columns}
                data={filteredData}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}

              />
            )}

          </div>
        </div>
      </div>

      {/* Comment Modal Component */}
      <CommentsModalpop
        show={showCommentModal}
        onHide={() => {
          setShowCommentModal(false);
          setSelectedLeadForComment(null);
        }}
        selectedLead={selectedLeadForComment}
        baseURL={baseURL} // Pass the baseURL
      />
      );
    </div>

  );
};

export default AdminViewLeads;
